/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Header_Signin1Inputs */

const zh_landing_header_signin1 = /** @type {(inputs: Landing_Header_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const en_landing_header_signin1 = /** @type {(inputs: Landing_Header_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_landing_header_signin1 = /** @type {(inputs: Landing_Header_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Landing_Header_Signin1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_header_signin1 = /** @type {((inputs?: Landing_Header_Signin1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Header_Signin1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_header_signin1(inputs)
	if (locale === "en") return en_landing_header_signin1(inputs)
	return es_landing_header_signin1(inputs)
});
export { landing_header_signin1 as "landing_header_signIn" }